module.exports = __webpack_public_path__ + "img/hand-holding-heart.df33b49a.svg";